export default __webpack_public_path__ + "static/media/chat.50c2cb85.svg";